/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useContext, useMemo, useState } from 'react';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import { useJourneyResultFormQuery } from 'entities/ApplicationForm/hooks/queries';
import { adaptParams } from 'shared/utils/getUserData';

const EditableDeductible = () => {
	const { defaultQuery, setInitialPayloadData, initialPayload } = useContext(FormDataContext);
	const [isEditing, setIsEditing] = useState(false);

	const query = useJourneyResultFormQuery();
	const data = query && adaptParams(query.coverage_info.parameters);
	const deductibleAssurant = data?.deductible;

	const deductibleChosen = initialPayload?.coverage.parameters.find(
		(item) => item.name === 'deductible'
	);

	const deductibleOptions = useMemo(() => {
		if (defaultQuery) {
			const deductible = defaultQuery.coveragesCue.parameters.find(
				(item) => item.name === 'deductibleOptions'
			);
			if (deductible && Array.isArray(deductible?.value) && deductibleAssurant) {
				return deductible.value.filter((item: number | string) => {
					const itemValue = typeof item === 'string' ? Number(item) : item;
					const minValue = Number(deductibleAssurant.substring(1));
					return itemValue >= minValue;
				});
			} else if (deductible && Array.isArray(deductible?.value)) {
				return deductible.value as (number | string)[];
			}
		}
		return [];
	}, [defaultQuery, deductibleAssurant]);

	const currentValue = deductibleChosen?.value || '';

	const handleEdit = () => {
		setIsEditing(true);
	};

	const handleChange = (event: { target: { value: string | number } }) => {
		const newValue = String(event.target.value);
		setInitialPayloadData((prevState) => {
			if (!prevState) return prevState;
			const newParametersData = prevState.coverage.parameters.map((item) => {
				if (item.name === 'deductible') {
					return { ...item, value: newValue };
				}
				return item;
			});
			return {
				...prevState,
				coverage: {
					parameters: newParametersData,
				},
			};
		});
		setIsEditing(false);
	};

	if (isEditing) {
		return (
			<Select
				value={currentValue}
				onChange={handleChange}
				onBlur={() => setIsEditing(false)}
				autoFocus
				size="small"
				sx={{ fontWeight: 700 }}
			>
				{deductibleOptions.map((option) => (
					<MenuItem key={option} value={option.toString()}>
						${option}
					</MenuItem>
				))}
			</Select>
		);
	}

	return (
		<Box
			display="flex"
			alignItems="center"
			gap={1}
			onClick={handleEdit}
			sx={{ cursor: 'pointer' }}
		>
			<EditIcon fontSize="inherit" />
			<Typography fontWeight={700} textAlign="right">
				${currentValue}
			</Typography>
		</Box>
	);
};

export default EditableDeductible;
